// import React, { useEffect, useRef } from 'react';
// import * as Chart from 'chart.js';
// import HeadingComponent from '../shared/heading';

// // ─── Line key detection — pattern-based, add new patterns here anytime ───────
// const LINE_KEY_PATTERNS = [
//   /^base\s*rent$/i,
//   /^base$/i,
//   /^occupancy$/i,
//   /^noi$/i,
//   /^vacancy(\s*rate)?$/i,
//   /^rate$/i,
// ];

// const isLineKey = (key) => LINE_KEY_PATTERNS.some((p) => p.test(key.trim()));

// // ─── Well-known key colors (fixed) ───────────────────────────────────────────
// const KNOWN_COLORS = {
//   'prior year': '#ADB9CA',
//   'budget':     '#F58035',
//   'actual':     '#17B1E8',
//   'base rent':  '#A9D18E',
//   'base':       '#E74C3C',   // red for Base
//   'occupancy':  '#C90A0A',
//   'noi':        '#FF6B9D',
//   'vacancy':    '#FFD700',
//   'vacancy rate': '#FFD700',
//   'expenses':   '#7B68EE',
//   'net rent':   '#20B2AA',
// };

// // ─── Color pool for any unknown future keys ───────────────────────────────────
// const COLOR_POOL = [
//   '#E74C3C', '#9B59B6', '#1ABC9C', '#F39C12', '#2ECC71', '#3498DB',
//   '#E67E22', '#16A085', '#8E44AD', '#D35400', '#27AE60', '#2980B9',
//   '#C0392B', '#7D3C98', '#148F77', '#B7950B', '#1E8449', '#1F618D',
// ];

// const LABEL_COL_WIDTH = 130;
// const ROW_HEIGHT       = 28;
// const HEADER_HEIGHT    = 28;

// // ─── Assign colors dynamically, memoised per render cycle ────────────────────
// const buildColorMap = (allKeys) => {
//   const map     = {};
//   let poolIdx   = 0;
//   allKeys.forEach((key) => {
//     const k = key.toLowerCase().trim();
//     if (KNOWN_COLORS[k]) {
//       map[key] = KNOWN_COLORS[k];
//     } else {
//       map[key] = COLOR_POOL[poolIdx % COLOR_POOL.length];
//       poolIdx++;
//     }
//   });
//   return map;
// };

// const parseChartHeightPx = (h) => parseInt(h, 10) || 400;

// const formatVal = (v) => {
//   if (v === null || v === undefined) return '-';
//   if (typeof v === 'string') return v;
//   return new Intl.NumberFormat('en-US').format(v);
// };

// const BarChartWithTable = ({
//   title         = '',
//   subtitle      = '',
//   inChartContent = '',
//   data,
//   chartHeight   = '400px',
//   showLegend    = true,
//   showTable     = true,
//   labelColWidth = LABEL_COL_WIDTH,
// }) => {
//   const chartRef      = useRef(null);
//   const chartInstance = useRef(null);

//   useEffect(() => {
//     if (!chartRef.current || !data) return;

//     const { labels, allKeys, seriesMap } = data;
//     if (!labels || !allKeys || !seriesMap) return;

//     const ctx       = chartRef.current.getContext('2d');
//     if (chartInstance.current) chartInstance.current.destroy();

//     const colorMap  = buildColorMap(allKeys);
//     const barKeys   = allKeys.filter((k) => !seriesMap[k].isLine);
//     const lineKeys  = allKeys.filter((k) => seriesMap[k].isLine);

//     // ─── Datasets ────────────────────────────────────────────────────────────
//     const datasets = [];

//     barKeys.forEach((key, bi) => {
//       const s        = seriesMap[key];
//       const color    = colorMap[key];
//       const isActual = /^actual$/i.test(key);
//       datasets.push({
//         label:             key,
//         type:              'bar',
//         data:              s.values,
//         backgroundColor:   isActual ? 'transparent' : color,
//         borderColor:       color,
//         borderWidth:       isActual ? 3 : 2,
//         categoryPercentage: 0.7,
//         barPercentage:     0.9,
//         maxBarThickness:   28,
//         _key:       key,
//         _isPercent: s.isPercent,
//         _rawValues: s.rawValues,
//         _barIndex:  bi,
//         _barTotal:  barKeys.length,
//       });
//     });

//     lineKeys.forEach((key) => {
//       const s     = seriesMap[key];
//       const color = colorMap[key];
//       datasets.push({
//         label:           key,
//         type:            'line',
//         data:            s.values,
//         borderColor:     color,
//         backgroundColor: 'transparent',
//         borderWidth:     2,
//         borderDash:   key === "Base Rent"?[2, 4]: key === "Base" || key ==="Occupancy"? [0]: [8, 4],
//         pointRadius:     3,
//         tension:         0.3,
//         order:           0,
//         _key:       key,
//         _isPercent: s.isPercent,
//         _rawValues: s.rawValues,
//       });
//     });

//     // ─── Bottom padding for table ─────────────────────────────────────────────
//     const tableBottomPadding = showTable
//       ? HEADER_HEIGHT + allKeys.length * ROW_HEIGHT + 12
//       : 0;

//     Chart.Chart.register(
//       Chart.BarController,
//       Chart.LineController,
//       Chart.BarElement,
//       Chart.LineElement,
//       Chart.PointElement,
//       Chart.CategoryScale,
//       Chart.LinearScale,
//       Chart.Tooltip,
//       Chart.Legend,
//     );

//     // ─── Shadow plugin ────────────────────────────────────────────────────────
//     const barShadowPlugin = {
//       id: 'barShadow',
//       beforeDatasetDraw(chart, args) {
//         const { ctx: c }  = chart;
//         const ds          = chart.data.datasets[args.index];
//         c.save();
//         if (ds.type !== 'line') {
//           c.shadowColor    = ds.borderColor || ds.backgroundColor;
//           c.shadowBlur     = 14;
//           c.shadowOffsetX  = 1;
//           c.shadowOffsetY  = 4;
//         } else {
//           c.shadowColor    = ds.borderColor;
//           c.shadowBlur     = 8;
//           c.shadowOffsetX  = 0;
//           c.shadowOffsetY  = 3;
//         }
//       },
//       afterDatasetDraw(chart) { chart.ctx.restore(); },
//     };

//     // ─── Value labels above/inside bars plugin ────────────────────────────────
//     const valueLabelPlugin = {
//       id: 'valueLabels',
//       afterDatasetsDraw(chart) {
//         const { ctx: c } = chart;
//         c.save();
//         c.font         = 'bold 10px Arial';
//         c.textAlign    = 'center';
//         c.textBaseline = 'middle';

//         const bh   = 17;
//         const step = 22;

//         // ── Pass 1: collect label specs, grouped by x-column (dataIndex) ──────
//         const groups = {};
//         chart.data.datasets.forEach((ds, di) => {
//           if (ds.type === 'line') return;
//           const meta  = chart.getDatasetMeta(di);
//           const total = ds._barTotal;
//           const bi    = ds._barIndex;

//           meta.data.forEach((bar) => {
//             const v = ds.data[bar.$context.index];
//             if (v === null || v === undefined) return;

//             const txt = formatVal(v);
//             const bw  = c.measureText(txt).width + 10;

//             let yOff;
//             if (total === 1)           yOff = bar.y - 14;
//             else if (bi === 0)         yOff = bar.y + step * (total - 1);
//             else if (bi === total - 1) yOff = bar.y - 10;
//             else                       yOff = bar.y + step * (total - 1 - bi) - 10;

//             // Clamp: label must not fall below the bar's bottom edge
//             if (yOff + bh / 2 > bar.base) yOff = bar.y - bh / 2 - 4;

//             const idx = bar.$context.index;
//             if (!groups[idx]) groups[idx] = [];
//             groups[idx].push({ bar, ds, txt, bw, yOff });
//           });
//         });

//         // ── Pass 2: resolve vertical overlaps per column (push downward) ──────
//         Object.values(groups).forEach((grp) => {
//           grp.sort((a, b) => a.yOff - b.yOff);
//           for (let i = 1; i < grp.length; i++) {
//             const minY = grp[i - 1].yOff + bh + 3;
//             if (grp[i].yOff < minY) grp[i].yOff = minY;
//           }
//         });

//         // ── Pass 3: draw all labels ────────────────────────────────────────────
//         Object.values(groups).forEach((grp) => {
//           grp.forEach(({ bar, ds, txt, bw, yOff }) => {
//             c.strokeStyle = ds.borderColor;
//             c.lineWidth   = 1.2;
//             c.strokeRect(bar.x - bw / 2, yOff - bh / 2, bw, bh);
//             c.shadowColor = 'transparent';
//             c.shadowBlur  = 0;
//             c.fillStyle   = '#ffffff';
//             c.fillText(txt, bar.x, yOff);
//           });
//         });

//         c.restore();
//       },
//     };

//     // ─── Canvas table plugin ──────────────────────────────────────────────────
//     const canvasTablePlugin = {
//       id: 'canvasTable',
//       afterDraw(chart) {
//         if (!showTable) return;
//         const { ctx: c, scales: { x }, chartArea: ca } = chart;
//         if (!x) return;

//         const lbls      = chart.data.labels;
//         const centers   = lbls.map((_, i) => x.getPixelForValue(i));
//         const colEdges  = [ca.left];
//         for (let i = 0; i < lbls.length - 1; i++) {
//           colEdges.push((centers[i] + centers[i + 1]) / 2);
//         }
//         colEdges.push(ca.right);

//         c.save();

//         const drawLine = (x1, y1, x2, y2) => {
//           c.beginPath();
//           c.strokeStyle = 'rgba(255,255,255,0.18)';
//           c.lineWidth   = 0.5;
//           c.moveTo(x1, y1);
//           c.lineTo(x2, y2);
//           c.stroke();
//         };

//         const tY  = ca.bottom + 4;
//         const lx  = ca.left - labelColWidth;

//         // Header background
//         c.fillStyle = 'rgba(255,255,255,0.04)';
//         c.fillRect(lx, tY, ca.right - lx, HEADER_HEIGHT);

//         // Header labels (month names)
//         c.font          = 'bold 10px Arial';
//         c.fillStyle     = '#ffffff';
//         c.textAlign     = 'center';
//         c.textBaseline  = 'middle';
//         lbls.forEach((lbl, i) => c.fillText(lbl, centers[i], tY + HEADER_HEIGHT / 2));

//         drawLine(lx, tY, ca.right, tY);
//         drawLine(lx, tY + HEADER_HEIGHT, ca.right, tY + HEADER_HEIGHT);

//         // Data rows — one per key, fully dynamic
//         allKeys.forEach((key, ri) => {
//           const s    = seriesMap[key];
//           const color = colorMap[key];
//           const ry   = tY + HEADER_HEIGHT + ri * ROW_HEIGHT;
//           const my   = ry + ROW_HEIGHT / 2;

//           // Row background
//           c.fillStyle = 'rgba(255,255,255,0.02)';
//           c.fillRect(lx, ry, ca.right - lx, ROW_HEIGHT);

//           // Color indicator (box or dashed line)
//           const ix = lx + 8;
//           if (s.isLine) {
//             c.save();
//             c.beginPath();
//             c.setLineDash([4, 3]);
//             c.strokeStyle = color;
//             c.lineWidth   = 2;
//             c.moveTo(ix, my);
//             c.lineTo(ix + 18, my);
//             c.stroke();
//             c.restore();
//           } else {
//             c.fillStyle = color;
//             c.fillRect(ix, my - 5, 18, 10);
//           }

//           // Key name as label
//           c.font      = '10px Arial';
//           c.fillStyle = '#ffffff';
//           c.textAlign = 'left';
//           c.fillText(key, ix + 26, my);

//           // Values per column
//           c.font      = '10px Arial';
//           c.textAlign = 'center';
//           s.values.forEach((v, ci) => {
//             const raw     = s.rawValues[ci];
//             const display = s.isPercent
//               ? (typeof raw === 'string' ? raw : `${v}%`)
//               : formatVal(v);
//             c.fillStyle = '#ffffff';
//             c.fillText(display, centers[ci], my);
//           });

//           drawLine(lx, ry + ROW_HEIGHT, ca.right, ry + ROW_HEIGHT);
//         });

//         // Vertical dividers
//         const endY = tY + HEADER_HEIGHT + allKeys.length * ROW_HEIGHT;
//         colEdges.forEach((ex) => drawLine(ex, tY, ex, endY));
//         drawLine(lx,               tY, lx,               endY);
//         drawLine(lx + labelColWidth, tY, lx + labelColWidth, endY);

//         c.restore();
//       },
//     };

//     // ─── Chart instance ───────────────────────────────────────────────────────
//     chartInstance.current = new Chart.Chart(ctx, {
//       type: 'bar',
//       data: { labels, datasets },
//       options: {
//         responsive:          true,
//         maintainAspectRatio: false,
//         plugins: {
//           legend:  { display: false },
//           tooltip: {
//             backgroundColor: 'rgba(0,0,0,0.85)',
//             padding:         12,
//             displayColors:   true,
//             callbacks: {
//               label: (context) => {
//                 const ds  = context.dataset;
//                 const v   = context.parsed.y;
//                 const raw = ds._rawValues?.[context.dataIndex];
//                 let lbl   = `${ds.label}: `;
//                 lbl += ds._isPercent
//                   ? (typeof raw === 'string' ? raw : `${v}%`)
//                   : new Intl.NumberFormat('en-US').format(v);
//                 return lbl;
//               },
//             },
//           },
//         },
//         scales: {
//           x: {
//             display: false,
//             grid:    { display: false },
//             offset:  true,
//           },
//           y: {
//             grid:  { color: 'rgba(255,255,255,0.07)', display: true },
//             ticks: {
//               color:    '#ffffff',
//               font:     { size: 11 },
//               callback: (v) => new Intl.NumberFormat('en-US').format(v),
//             },
//             beginAtZero: true,
//           },
//         },
//         layout: {
//           padding: {
//             top:    55,
//             bottom: tableBottomPadding,
//             left:   labelColWidth,
//             right:  0,
//           },
//         },
//       },
//       plugins: [barShadowPlugin, valueLabelPlugin, canvasTablePlugin],
//     });

//     return () => {
//       if (chartInstance.current) chartInstance.current.destroy();
//     };
//   }, [data, showTable, labelColWidth]);

//   if (!data) return null;

//   const { allKeys, seriesMap } = data;
//   const colorMap = buildColorMap(allKeys);

//   // ─── Canvas total height ──────────────────────────────────────────────────
//   const chartPx        = parseChartHeightPx(chartHeight);
//   const canvasTotalHeight = showTable
//     ? chartPx + HEADER_HEIGHT + allKeys.length * ROW_HEIGHT + 20
//     : chartPx;

//   // ─── Legend items ─────────────────────────────────────────────────────────
//   const legendItems = allKeys.map((key) => {
//     const s       = seriesMap[key];
//     const color   = colorMap[key];
//     const isActual = /^actual$/i.test(key);
//     return {
//       key,
//       label: key,
//       el: s.isLine ? (
//         <span
//           style={{
//             display:       'inline-block',
//             width:         28,
//             height:        0,
//             borderTop:     `2px dashed ${color}`,
//             marginTop:     5,
//           }}
//         />
//       ) : (
//         <span
//           style={{
//             display:         'inline-block',
//             width:           28,
//             height:          10,
//             borderRadius:    2,
//             background:      isActual ? 'transparent' : color,
//             border:          isActual ? `2px solid ${color}` : 'none',
//           }}
//         />
//       ),
//     };
//   });

//   return (
//     <div
//       className="min-h-screen p-8 text-foreground transition-colors"
//       style={{ zoom: '70%' }}
//     >
//       <div style={{ width: '100%' }}>

//         {/* Title bar */}
//         <div
//           className="flex flex-col gap-1 mb-1"
//           style={{
//             backgroundColor: '#ffffff',
//             padding:         '2rem',
//             margin:          '-2rem -2rem 2rem -2rem',
//           }}
//         >
//           {title    && <HeadingComponent variant="main">{title}</HeadingComponent>}
//           {subtitle && <HeadingComponent variant="sub">{subtitle}</HeadingComponent>}
//         </div>

//         {/* Chart card */}
//         <div
//           style={{
//             borderRadius:    8,
//             padding:         '16px 20px',
//             backgroundColor: '#464647',
//             border:          '1px solid rgba(255,255,255,0.1)',
//             boxShadow:       '0 4px 24px rgba(0,0,0,0.4)',
//           }}
//         >
//           {inChartContent && (
//             <h2
//               style={{
//                 color:        '#fff',
//                 textAlign:    'center',
//                 fontSize:     23,
//                 marginBottom: 12,
//                 fontWeight:   500,
//               }}
//             >
//               {inChartContent}
//             </h2>
//           )}

//           {/* Canvas */}
//           <div style={{ minHeight: '700px' }}>
//             <canvas
//               ref={chartRef}
//               style={{ width: '100%', height: canvasTotalHeight }}
//               height={canvasTotalHeight}
//             />
//           </div>

//           {/* Legend */}
//           {showLegend && (
//             <div
//               style={{
//                 display:        'flex',
//                 flexWrap:       'wrap',
//                 justifyContent: 'center',
//                 alignItems:     'center',
//                 gap:            20,
//                 marginTop:      20,
//                 paddingTop:     12,
//               }}
//             >
//               {legendItems.map((item) => (
//                 <div
//                   key={item.key}
//                   style={{ display: 'flex', alignItems: 'center', gap: 6 }}
//                 >
//                   {item.el}
//                   <span style={{ color: '#fff', fontSize: 11 }}>{item.label}</span>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BarChartWithTable;









import React, { useEffect, useRef } from 'react';
import * as Chart from 'chart.js';
import HeadingComponent from '../shared/heading';

const DEFAULT_COLORS = {
  priorYear: '#b8bfc9',
  budget:    '#F58035',
  actual:    '#17B1E8',
};

const BORDER_STYLE    = '1px solid #ffffff';
const LABEL_COL_WIDTH = 130;

const FIELD_CONFIG = {
  priorYear: { label: 'Prior Year', type: 'bar', colorKey: 'priorYear', solidFill: true  },
  budget:    { label: 'Budget',     type: 'bar', colorKey: 'budget',    solidFill: true  },
  actual:    { label: 'Actual',     type: 'bar', colorKey: 'actual',    solidFill: false },
};

const BarChartWithTable = ({
  title          = '',
  subtitle       = '',
  inChartContent = '',
  data,
  chartHeight    = '400px',
  showLegend     = true,
  showTable      = true,
  baseLines      = [],
  colors         = {},
  labelColWidth  = LABEL_COL_WIDTH,
}) => {
  const chartRef        = useRef(null);
  const chartInstance   = useRef(null);
  const tableWrapperRef = useRef(null);
  const labelColRef = useRef(null);  // ← yeh add karo
  const containerRef = useRef(null);



  const resolveColor = (cssVar, propKey, fallback) => {
    if (colors[propKey]) return colors[propKey];
    const styles  = getComputedStyle(document.documentElement);
    const fromCss = styles.getPropertyValue(cssVar).trim();
    return fromCss || fallback;
  };

  useEffect(() => {
    if (!chartRef.current || !data) return;

    const ctx = chartRef.current.getContext('2d');
    if (chartInstance.current) chartInstance.current.destroy();

    const fPY     = resolveColor('--chart-prior-year', 'priorYear', DEFAULT_COLORS.priorYear);
    const fBudget = resolveColor('--chart-budget',     'budget',    DEFAULT_COLORS.budget);
    const fActual = resolveColor('--chart-actual',     'actual',    DEFAULT_COLORS.actual);

    const fieldColors = { priorYear: fPY, budget: fBudget, actual: fActual };
    const textColor   = '#ffffff';

    Chart.Chart.register(
      Chart.BarController,
      Chart.LineController,
      Chart.BarElement,
      Chart.LineElement,
      Chart.PointElement,
      Chart.CategoryScale,
      Chart.LinearScale,
      Chart.Tooltip,
      Chart.Legend
    );

    const isSeriesPercent = (key) => !!data[key + 'Raw'];
    const formatBarValue  = (v)   => new Intl.NumberFormat('en-US').format(v);
    const formatTick      = (v)   => new Intl.NumberFormat('en-US').format(v);

    const availableFields  = data.availableFields || ['priorYear', 'budget', 'actual'];
    const barFields        = availableFields.filter(f => FIELD_CONFIG[f]);
    const barDatasetColors = barFields.map(f => fieldColors[f] || '#fff');

    // Bar datasets
    const datasets = barFields.map(f => {
      const cfg   = FIELD_CONFIG[f];
      const color = fieldColors[f] || '#fff';
      return {
        label:              cfg.label,
        data:               data[f],
        backgroundColor:    cfg.solidFill ? color : 'transparent',
        borderColor:        color,
        borderWidth:        cfg.solidFill ? 2 : 3,
        categoryPercentage: 0.55,
        barPercentage:      0.95,
        maxBarThickness:    28,
        order:              2,
      };
    });

    // Line datasets from baseLines prop
    // solid: true  → solid line (no dash)
    // isRound:true → round dotted line
    // dashPattern  → custom dash array
    baseLines.forEach(line => {
      if (!data[line.key]) return;

      const isSolid = line.solid === true;

      datasets.push({
        label:           line.label,
        data:            data[line.key],
        type:            'line',
        borderColor:     line.color,
        backgroundColor: 'transparent',
        borderWidth:     4,
        borderDash:      isSolid ? [] : (line.dashPattern || [6, 3]),
        borderCapStyle:  (!isSolid && line.isRound) ? 'round' : 'butt',
        pointRadius:     0,
        tension:         (!isSolid && line.isRound) ? 0.0 : 0,
        order:           0,
        _seriesKey:      line.key,
      });
    });

    // Align table with chart y-axis
   const alignTablePlugin = {
  id: 'alignTable',
  afterLayout(chart) {
    const yAxisRight = chart.scales?.y?.right ?? 0;
    const padding = yAxisRight - 4;
    
    if (tableWrapperRef.current) {
      tableWrapperRef.current.style.paddingLeft = `${padding}px`;
    }
    if (labelColRef.current) {
      labelColRef.current.style.marginRight = `-${padding}px`;
    }
  },
};

    // Year separator vertical lines
    const yearSeparatorPlugin = {
      id: 'yearSeparator',
      afterDraw(chart) {
        if (!data.yearRanges || data.yearRanges.length <= 1) return;
        const ctx   = chart.ctx;
        const meta  = chart.getDatasetMeta(0);
        const yAxis = chart.scales.y;
        let cumIndex = 0;
        data.yearRanges.forEach((range, i) => {
          cumIndex += range.span;
          if (i === data.yearRanges.length - 1) return;
          const barBefore = meta.data[cumIndex - 1];
          const barAfter  = meta.data[cumIndex];
          if (!barBefore || !barAfter) return;
          const x = (barBefore.x + barAfter.x) / 2;
          ctx.save();
          ctx.beginPath();
          ctx.strokeStyle = 'rgba(255,255,255,0.7)';
          ctx.lineWidth   = 3;
          ctx.setLineDash([]);
          ctx.moveTo(x, yAxis.top);
          ctx.lineTo(x, yAxis.bottom);
          ctx.stroke();
          ctx.restore();
        });
      },
    };

    // Bar shadow plugin
    const barShadowPlugin = {
      id: 'barShadow',
      beforeDatasetDraw(chart, args) {
        const { ctx } = chart;
        const dataset  = chart.data.datasets[args.index];
        ctx.save();
        if (dataset.type !== 'line') {
          ctx.shadowColor   = dataset.borderColor || dataset.backgroundColor;
          ctx.shadowBlur    = 18;
          ctx.shadowOffsetX = 2;
          ctx.shadowOffsetY = 6;
        }
      },
      afterDatasetDraw(chart) {
        chart.ctx.restore();
      },
    };

    // Value label drawing plugin
    const labelDrawPlugin = {
  id: 'labelDraw',
  afterDatasetsDraw(chart) {
    const ctx = chart.ctx;
    ctx.save();
    ctx.font = 'bold 11px Arial';

    const chartTop    = chart.scales.y.top + 4;
    const chartBottom = chart.scales.y.bottom - 4;
    const allLabels   = [];

    // --- 1. Collect all labels ---
    chart.data.datasets.forEach((dataset, dsIdx) => {
      if (dataset.type === 'line') return;
      const barOnlyDatasets = chart.data.datasets.filter(d => d.type !== 'line');
      const barIndex        = barOnlyDatasets.indexOf(dataset);
      if (barIndex === -1) return;

      const meta      = chart.getDatasetMeta(dsIdx);
      const totalBars = barOnlyDatasets.length;

      meta.data.forEach((bar) => {
        const value = dataset.data[bar.$context.index];
        if (!value) return;
        const text = formatBarValue(value);
        const bw   = ctx.measureText(text).width + 14;
        const bh   = 22;
        let xPos = bar.x, yPos = bar.y;

        if (totalBars === 1) {
          xPos = bar.x;      yPos = bar.y - 12;
        } else if (totalBars === 2) {
          if (barIndex === 0) { xPos = bar.x - 10; yPos = bar.y + 28; }
          else                { xPos = bar.x + 10; yPos = bar.y - 12; }
        } else {
          if (barIndex === 0)      { xPos = bar.x - 14; yPos = bar.y + 50; }
          else if (barIndex === 1) { xPos = bar.x;      yPos = bar.y - 12; }
          else                     { xPos = bar.x + 14; yPos = bar.y + 28; }
        }

        allLabels.push({
          text, xPos, yPos, bw, bh,
          origY:  yPos,
          barX:   bar.x,
          barY:   bar.y,   // ← anchor: label ka natural reference point
          color:  barDatasetColors[barIndex] || '#fff',
        });
      });
    });

    // --- 2. Robust overlap resolution (ChartTableComponent style) ---
    const V_GAP = 4;
    const H_GAP = 3;
    const MAX_PASSES = 50;

    const rectsOverlap = (a, b) => {
      return !(
        (a.xPos + a.bw / 2 + H_GAP) < (b.xPos - b.bw / 2) ||
        (a.xPos - a.bw / 2 - H_GAP) > (b.xPos + b.bw / 2) ||
        (a.yPos + a.bh / 2 + V_GAP) < (b.yPos - b.bh / 2) ||
        (a.yPos - a.bh / 2 - V_GAP) > (b.yPos + b.bh / 2)
      );
    };

    for (let pass = 0; pass < MAX_PASSES; pass++) {
      let anyMoved = false;

      for (let i = 0; i < allLabels.length; i++) {
        for (let j = i + 1; j < allLabels.length; j++) {
          const a = allLabels[i];
          const b = allLabels[j];

          if (!rectsOverlap(a, b)) continue;

          anyMoved = true;

          const aAbove  = a.yPos < a.barY;   // label is above its bar top
          const bAbove  = b.yPos < b.barY;

          // How much they overlap vertically
          const overlapAmt = (a.yPos + a.bh / 2 + V_GAP) - (b.yPos - b.bh / 2);

          if (aAbove && bAbove) {
            // Both above → push them apart on their axis
            if (a.yPos <= b.yPos) {
              a.yPos = Math.max(chartTop, a.yPos - overlapAmt / 2);
              b.yPos = Math.min(chartBottom, b.yPos + overlapAmt / 2);
            } else {
              b.yPos = Math.max(chartTop, b.yPos - overlapAmt / 2);
              a.yPos = Math.min(chartBottom, a.yPos + overlapAmt / 2);
            }
          } else if (!aAbove && !bAbove) {
            // Both below → same
            if (a.yPos >= b.yPos) {
              b.yPos = Math.max(chartTop, b.yPos - overlapAmt / 2);
              a.yPos = Math.min(chartBottom, a.yPos + overlapAmt / 2);
            } else {
              a.yPos = Math.max(chartTop, a.yPos - overlapAmt / 2);
              b.yPos = Math.min(chartBottom, b.yPos + overlapAmt / 2);
            }
          } else {
            // One above, one below → push each to their side
            if (aAbove) {
              a.yPos = Math.max(chartTop,    a.yPos - overlapAmt / 2);
              b.yPos = Math.min(chartBottom, b.yPos + overlapAmt / 2);
            } else {
              b.yPos = Math.max(chartTop,    b.yPos - overlapAmt / 2);
              a.yPos = Math.min(chartBottom, a.yPos + overlapAmt / 2);
            }
          }
        }
      }

      if (!anyMoved) break; // Stable — no more passes needed
    }

    // --- 3. Draw labels ---
    allLabels.forEach(({ text, xPos, yPos, bw, bh, origY, barX, barY, color }) => {
      // Connector line if label was pushed away from original position
      if (Math.abs(yPos - origY) > 8) {
        ctx.beginPath();
        ctx.strokeStyle = color + 'aa';
        ctx.lineWidth   = 1;
        ctx.setLineDash([3, 2]);
        ctx.moveTo(barX, barY + 6);
        ctx.lineTo(xPos, yPos + bh / 2);
        ctx.stroke();
        ctx.setLineDash([]);
      }

      ctx.strokeStyle  = color;
      ctx.lineWidth    = 1.5;
      ctx.strokeRect(xPos - bw / 2, yPos - bh / 2, bw, bh);
      ctx.shadowColor  = 'transparent';
      ctx.shadowBlur   = 0;
      ctx.fillStyle    = '#ffffff';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(text, xPos, yPos);
    });

    ctx.restore();
  },
};

    chartInstance.current = new Chart.Chart(ctx, {
      type: 'bar',
      data: { labels: data.labels, datasets },
      options: {
        responsive:          false,
        maintainAspectRatio: false,
        plugins: {
          legend:  { display: false },
          tooltip: {
            backgroundColor: 'rgba(0,0,0,0.85)',
            padding:         12,
            displayColors:   true,
            callbacks: {
              label: (context) => {
                let lbl = context.dataset.label || '';
                if (lbl) lbl += ': ';
                const key = context.dataset._seriesKey;
                if (key && isSeriesPercent(key)) {
                  lbl += `${context.parsed.y}%`;
                } else {
                  lbl += new Intl.NumberFormat('en-US').format(context.parsed.y);
                }
                return lbl;
              },
            },
          },
        },
        scales: {
          x: { display: false, grid: { display: false }, border: { display: false } },
          y: {
            grid:        { color: 'rgba(255,255,255,0.08)', display: false },
            border:      { display: false },
            ticks:       { color: textColor, font: { size: 11 }, callback: formatTick },
            beginAtZero: true,
          },
        },
        layout: { padding: { top: 50, bottom: 0, left: 0, right: 20 } },
      },
      plugins: [barShadowPlugin, alignTablePlugin, labelDrawPlugin],
    });

    const resizeObserver = new ResizeObserver(() => {
  if (!containerRef.current || !chartInstance.current) return;
  const w = containerRef.current.offsetWidth;
  const h = containerRef.current.offsetHeight;
  chartInstance.current.resize(w, h);
});
if (containerRef.current) resizeObserver.observe(containerRef.current);

return () => {
  resizeObserver.disconnect();
  if (chartInstance.current) chartInstance.current.destroy();
};
  }, [data, baseLines, colors]);

  if (!data) return null;

  const styles = typeof window !== 'undefined' ? getComputedStyle(document.documentElement) : {};
  const getC   = (cssVar, propKey, fallback) =>
    colors[propKey] || (styles.getPropertyValue ? styles.getPropertyValue(cssVar).trim() : '') || fallback;

  const cPY     = getC('--chart-prior-year', 'priorYear', DEFAULT_COLORS.priorYear);
  const cBudget = getC('--chart-budget',     'budget',    DEFAULT_COLORS.budget);
  const cActual = getC('--chart-actual',     'actual',    DEFAULT_COLORS.actual);

  const fieldColorMap   = { priorYear: cPY, budget: cBudget, actual: cActual };
  const availableFields = data.availableFields || ['priorYear', 'budget', 'actual'];

  // Bar table rows
  const tableRows = availableFields
    .filter(f => FIELD_CONFIG[f] && data[f])
    .map(f => {
      const cfg   = FIELD_CONFIG[f];
      const color = fieldColorMap[f] || '#fff';
      const indicator = cfg.solidFill
        ? <span style={{ display:'inline-block', width:'24px', height:'10px', backgroundColor:color, borderRadius:'2px', flexShrink:0 }} />
        : <span style={{ display:'inline-block', width:'24px', height:'10px', border:`2px solid ${color}`, backgroundColor:'transparent', borderRadius:'2px', flexShrink:0 }} />;
      return { label: cfg.label, values: data[f], isPercentRow: false, indicator };
    });

  // Line table rows from baseLines
  baseLines
    .filter(l => data[l.key])
    .forEach(line => {
      const isSolid = line.solid === true;
      tableRows.push({
        label:        line.label,
        values:       data[line.key + 'Raw'] ?? data[line.key],
        isPercentRow: !!data[line.key + 'Raw'],
        indicator: isSolid
          // Solid line indicator
          ? <span style={{ display:'inline-block', width:'24px', height:'2px', backgroundColor: line.color, flexShrink:0, marginTop:'5px' }} />
          // Dashed/dotted line indicator
          : <span style={{ display:'inline-block', width:'24px', height:'2px', borderTop:`2px dashed ${line.color}`, flexShrink:0, marginTop:'5px' }} />,
      });
    });

  // Legend items
  const legendItems = availableFields
    .filter(f => FIELD_CONFIG[f] && data[f])
    .map(f => {
      const cfg   = FIELD_CONFIG[f];
      const color = fieldColorMap[f] || '#fff';
      const el = cfg.solidFill
        ? <span style={{ display:'inline-block', width:'32px', height:'12px', backgroundColor:color, borderRadius:'2px' }} />
        : <span style={{ display:'inline-block', width:'32px', height:'12px', border:`2px solid ${color}`, backgroundColor:'transparent', borderRadius:'2px' }} />;
      return { label: cfg.label, el };
    });

  baseLines
    .filter(l => data[l.key])
    .forEach(line => {
      const isSolid = line.solid === true;
      legendItems.push({
        label: line.label,
        el: isSolid
          ? <span style={{ display:'inline-block', width:'32px', height:'2px', backgroundColor: line.color, marginTop:'5px' }} />
          : <span style={{ display:'inline-block', width:'32px', borderTop:`2px dashed ${line.color}`, marginTop:'5px' }} />,
      });
    });

  // Year boundary set
  const yearBoundarySet = new Set();
  if (data.yearRanges) {
    let cum = 0;
    data.yearRanges.forEach((range, i) => {
      cum += range.span;
      if (i < data.yearRanges.length - 1) yearBoundarySet.add(cum - 1);
    });
  }

  return (
    <div className="min-h-screen p-8 text-foreground transition-colors" style={{ zoom: "70%" }}>
      <div style={{ width:'100%' }}>

        <div
          className="flex flex-col gap-1 mb-1"
          style={{ backgroundColor:"#ffffff", padding:"2rem", margin:"-2rem -2rem 2rem -2rem" }}
        >
          {title    && <HeadingComponent variant={"main"}>{title}</HeadingComponent>}
          {subtitle && <HeadingComponent variant={"sub"}>{subtitle}</HeadingComponent>}
        </div>

        <div style={{
          borderRadius: '8px',
          padding:      '16px 20px',
          background:   'radial-gradient(ellipse at center, #525254 0%, #3a3a3c 45%, #1e1e1f 100%)',
          border:       '1px solid rgba(255,255,255,0.1)',
          boxShadow:    '0 4px 24px rgba(0,0,0,0.4)',
        }}>

          {inChartContent && (
            <h2 style={{ color:'#fff', textAlign:'center', fontSize:'23px', marginBottom:'12px', fontWeight:'500' }}>
              {inChartContent}
            </h2>
          )}

          <div style={{ display:'flex', width:'100%' }}>

            {/* Label Column */}
            <div
              ref={labelColRef}  // ← yeh add karo
 style={{ flexShrink:0, width:`${labelColWidth}px`, marginRight: ' -30px' }}>

              <div style={{ height: chartHeight }} />
              {showTable && (
                <div>
                  {data.yearRanges && <div style={{ height:'32px' }} />}
                  <div style={{ height:'32px' }} />
                  {tableRows.map((row) => (
                    <div
                      key={row.label}
                      style={{
                        height:      '32px',
                        display:     'flex',
                        alignItems:  'center',
                        gap:         '6px',
                        padding:     '0 8px',
                        border:      BORDER_STYLE,
                        borderRight: BORDER_STYLE,
                        marginTop:   '-1px',
                        whiteSpace:  'nowrap',
                        overflow:    'hidden',
                      }}
                    >
                      {row.indicator}
                      <span style={{ color:'#fff', fontSize:'13px' }}>{row.label}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Chart + Table Data Column */}
            <div style={{ flex:1, minWidth:0 }}>
              <div ref={containerRef} style={{ height: chartHeight, width:'100%' }}>
  <canvas ref={chartRef} style={{ width:'100%', height:'100%' }} />
</div>

              {showTable && (
                <div ref={tableWrapperRef} style={{ backgroundColor:'transparent' }}>
                  <div style={{ overflowX:'auto' }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', tableLayout:'fixed' }}>
                      <thead>
                        {data.yearRanges && (
                          <tr>
                            {data.yearRanges.map((range, idx) => (
                              <th
                                key={range.year}
                                colSpan={range.span}
                                style={{
                                  textAlign:     'center',
                                  padding:       '6px 4px',
                                  color:         '#fff',
                                  fontSize:      '12px',
                                  fontWeight:    'bold',
                                  background:    'linear-gradient(180deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.06) 100%)',
                                  border:        BORDER_STYLE,
                                  borderRight:   idx < data.yearRanges.length - 1 ? '3px solid rgba(255,255,255,0.6)' : BORDER_STYLE,
                                  letterSpacing: '1px',
                                }}
                              >
                                {range.year}
                              </th>
                            ))}
                          </tr>
                        )}
                        <tr>
                          {data.labels.map((lbl, i) => (
                            <th
                              key={i}
                              style={{
                                textAlign:  'center',
                                padding:    '6px 4px',
                                color:      '#fff',
                                fontSize:   '11px',
                                fontWeight: '600',
                                border:     BORDER_STYLE,
                              }}
                            >
                              {lbl}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableRows.map((row) => (
                          <tr key={row.label}>
                            {row.values.map((val, i) => (
                              <td
                                key={i}
                                style={{
                                  textAlign: 'center',
                                  padding:   '6px 4px',
                                  color:     '#fff',
                                  fontSize:  '11px',
                                  height:    '32px',
                                  border:    BORDER_STYLE,
                                }}
                              >
                                {row.isPercentRow
                                  ? (typeof val === 'string' ? val : `${val}%`)
                                  : (typeof val === 'number' ? val.toLocaleString() : val)
                                }
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>

          </div>

          {showLegend && (
            <div style={{
              display:        'flex',
              flexWrap:       'wrap',
              justifyContent: 'center',
              alignItems:     'center',
              gap:            '24px',
              paddingTop:     '10px',
              paddingBottom:  '4px',
            }}>
              {legendItems.map((item) => (
                <div key={item.label} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  {item.el}
                  <span style={{ color:'#fff', fontSize:'11px' }}>{item.label}</span>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default BarChartWithTable;